import React from 'react';
import type { AfcCandidateSearch, Experience } from '@axiom/validation';
import {
  CompanyLogo,
  CondensedHeader,
  Divider,
  Gutter,
  LogoUtil,
} from '@axiom/ui';

export const DiscoverTalentCarouselExperiences = ({
  candidate,
  name,
}: {
  candidate: AfcCandidateSearch;
  name?: string;
}) => {
  const clientNamesSet = new Set();
  const clientLogosSet = new Set();

  const clientNames = candidate.experiences
    .reduce<Array<Experience['client']>>((crnt, data) => {
      if (data.client && !clientNamesSet.has(data.client)) {
        clientNamesSet.add(data.client);
        crnt.push(data.client);
      }

      return crnt;
    }, [])
    .slice(0, 5);

  const clientLogos = candidate.experiences
    .reduce<Array<Experience['clientDomain']>>((crnt, data) => {
      if (data.clientDomain && !clientLogosSet.has(data.clientDomain)) {
        clientLogosSet.add(data.clientDomain);
        crnt.push(data.clientDomain);
      }

      return crnt;
    }, [])
    .slice(0, 5);

  return clientNames.length > 0 || clientLogos.length > 0 ? (
    <>
      <CondensedHeader name={name || 'EXPERIENCES_IN_HOUSE'}>
        In House Experience
      </CondensedHeader>
      {clientNames.length > 0 ? (
        <>
          <Divider>
            {clientNames.map(client => {
              return (
                <span data-test="EXPERIENCE_NAME" key={client}>
                  {client}
                </span>
              );
            })}
          </Divider>
          <Gutter bottom="8px" />
        </>
      ) : null}

      {clientLogos.map(clientDomain => {
        return (
          <Gutter right="16px" as="span" key={clientDomain}>
            <CompanyLogo
              name="EXPERIENCE_LOGO"
              src={LogoUtil.getUrl(clientDomain)}
              fallback={null}
              alt={`Logo for: ${clientDomain}`}
              width="48px"
            />
          </Gutter>
        );
      })}
    </>
  ) : null;
};
